/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'gatsby';
import Logo from '@/images/logo.svg';
import { compose, render } from '@/utils/story-composer';
import MenuContext from '@/context/menu-context';
import Button from '@/components/elements/button';

function Header({ pageContext, elementProps, menu, buttonsTopMenu, buttonsSideMenu }) {
	const { t, i18n } = useTranslation();
	const { location } = pageContext;

	const topMenu = render(menu, { place: 'top', location });
	const sideMenu = render(menu, { place: 'side', buttonsSideMenu, location });

	const [menuOpen, setMenuOpen] = useState(false);
	const openMenu = () => setMenuOpen(true);
	const closeMenu = () => setMenuOpen(false);

	const currentLanguage = i18n.resolvedLanguage.toLocaleLowerCase();
	const localizedHomeLink = `/${currentLanguage}`;

	return (
		<header {...elementProps}>
			<MenuContext.Provider value={{ menuOpen, openMenu, closeMenu }}>
				<div className="shadow-header fixed z-30 h-20 w-full bg-white">
					<div className="flex justify-between h-full items-center px-6 lg:px-10">
						<div className="flex flex-1 md:flex-2 lg:justify-center">{topMenu}</div>
						<div className="flex flex-1 justify-end md:justify-center lg:order-first lg:justify-start">
							<Link to={localizedHomeLink} alt={t('gynzy-com.go-to-home')} title={t('gynzy-com.go-to-home')}>
								<Logo />
							</Link>
						</div>
						<div className="flex-1 items-center hidden md:flex justify-end">
							{buttonsTopMenu &&
								buttonsTopMenu.map(button => (
									<div key={button._uid} className="flex ml-2">
										<Button {...button} customClasses="w-fit" />
									</div>
								))}
						</div>
					</div>
				</div>
				<div className="lg:hidden fixed w-full md:w-110 z-10 shadow-side-menu">{sideMenu}</div>
			</MenuContext.Provider>
		</header>
	);
}

export default Header;

compose('header', Header, { children: ['buttonsSideMenu'] });
